// Wires clicks on .variant-combo-grid__cell (variant-combo-swatches.liquid) to
// the native, hidden <variant-picker> radios: checks the two matching radios
// (row option + column option) and dispatches one 'change' event, so the
// existing VariantPicker component (assets/variant-picker.js) handles price,
// media, url and add-to-cart exactly as it would for a direct radio click.
//
// Event delegation on document means this keeps working after the section
// re-renders itself (morph replaces the grid's DOM nodes on every selection).
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const cell = target.closest('.variant-combo-grid__cell');
  if (!cell || cell.getAttribute('aria-disabled') === 'true') return;

  const grid = cell.closest('.variant-combo-grid');
  const variantPicker = cell.closest('variant-picker');
  if (!(grid instanceof HTMLElement) || !variantPicker) return;

  const rowOptionName = grid.dataset.rowOptionName;
  const colOptionName = grid.dataset.colOptionName;
  const rowValue = cell.getAttribute('data-row-value');
  const colValue = cell.getAttribute('data-col-value');
  if (!rowOptionName || !colOptionName || rowValue === null || colValue === null) return;

  const rowInput = variantPicker.querySelector(
    `input[data-option-name="${CSS.escape(rowOptionName)}"][value="${CSS.escape(rowValue)}"]`
  );
  const colInput = variantPicker.querySelector(
    `input[data-option-name="${CSS.escape(colOptionName)}"][value="${CSS.escape(colValue)}"]`
  );
  if (!(rowInput instanceof HTMLInputElement) || !(colInput instanceof HTMLInputElement)) return;

  rowInput.checked = true;
  colInput.checked = true;

  // VariantPicker.variantChanged() reads the *target* radio's own
  // data-variant-id to update the URL and add-to-cart (via ProductSelectEvent)
  // — that attribute is baked in at the last server render assuming the
  // *other* option stays put, which is exactly what a combo-grid click
  // breaks (both options change at once). Overwrite it with this cell's own
  // pre-resolved variant id (data-variant-id, set server-side in
  // variant-combo-swatches.liquid from the matching product.variants entry)
  // so the correct variant actually gets added to cart.
  const variantId = cell.getAttribute('data-variant-id');
  if (variantId) {
    colInput.dataset.variantId = variantId;
  } else {
    delete colInput.dataset.variantId;
  }

  if (typeof (/** @type {any} */ (variantPicker).updateSelectedOption) === 'function') {
    /** @type {any} */ (variantPicker).updateSelectedOption(rowInput);
    /** @type {any} */ (variantPicker).updateSelectedOption(colInput);
  }

  colInput.dispatchEvent(new Event('change', { bubbles: true }));
});
